import React from 'react';
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const PrimaryBreadcrumb = ({
  items = [],
  sx = {},
  separatorColor = '#525252',
  separatorFontSize = '0.875rem',
  linkColor = '#585858',
  currentColor = '#383838',
  linkFontSize = '1rem',
  currentFontSize = '1rem',
  linkFontWeight = 400,
  currentFontWeight = 500,
  ...props
}) => {
  const navigate = useNavigate();

  const handleClick = (e, item) => {
    e.preventDefault();
    if (item.onClick) {
      item.onClick();
    } else if (item.path) {
      navigate(item.path);
    }
  };

  const baseStyles = {
    mb: 2,
    '& .MuiBreadcrumbs-ol': {
      alignItems: 'baseline',
    },
  };

  const linkStyles = {
    fontFamily: 'IBM Plex Sans, sans-serif',
    fontWeight: linkFontWeight,
    fontStyle: 'normal',
    fontSize: linkFontSize,
    lineHeight: '100%',
    letterSpacing: '0%',
    color: linkColor,
    textDecoration: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'baseline',
    '&:hover': {
      textDecoration: 'underline',
    },
  };

  const currentStyles = {
    color: currentColor,
    fontFamily: 'IBM Plex Sans, sans-serif',
    fontWeight: currentFontWeight,
    fontStyle: 'normal',
    fontSize: currentFontSize,
    lineHeight: '100%',
    letterSpacing: '0%',
    display: 'inline-flex',
    alignItems: 'baseline',
  };

  return (
    <MuiBreadcrumbs
      aria-label="breadcrumb"
      sx={{
        ...baseStyles,
        ...sx,
      }}
      separator={
        <Typography sx={{ color: separatorColor, fontSize: separatorFontSize }}>›</Typography>
      }
      {...props}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        if (isLast) {
          return (
            <Typography key={index} sx={currentStyles}>
              {item.label}
            </Typography>
          );
        }

        return (
          <Link
            key={index}
            component="button"
            variant="body2"
            onClick={(e) => handleClick(e, item)}
            sx={linkStyles}
          >
            {item.label}
          </Link>
        );
      })}
    </MuiBreadcrumbs>
  );
};

PrimaryBreadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string,
      onClick: PropTypes.func,
    })
  ).isRequired,
  sx: PropTypes.object,
  separatorColor: PropTypes.string,
  separatorFontSize: PropTypes.string,
  linkColor: PropTypes.string,
  currentColor: PropTypes.string,
  linkFontSize: PropTypes.string,
  currentFontSize: PropTypes.string,
  linkFontWeight: PropTypes.number,
  currentFontWeight: PropTypes.number,
};

export default PrimaryBreadcrumb;

